import EppoFlags from '@/EppoFlags';
import {useBooleanAssignment} from '@/eppoHooks';
import useIdentity from '@/hooks/useIdentity';

const useOrdererConnectionsCheck = () => {
  const {data: identityData, loading} = useIdentity();
  const currentUserVerified = identityData?.me?.consumerAccount?.corporateAccountVerified ?? false;
  const corpAccountId = identityData?.me?.consumerAccount?.corporateAccount?.id ?? '';
  const featureFlagEnabled = useBooleanAssignment(EppoFlags.CorporateConnections, {corpAccountId});
  const ordererConnectionsEnabled = featureFlagEnabled && currentUserVerified;

  return {ordererConnectionsEnabled, loading};
};

export default useOrdererConnectionsCheck;
